import { render, staticRenderFns } from "./StandingsListSection.vue?vue&type=template&id=2c0bff76&scoped=true"
import script from "./StandingsListSection.vue?vue&type=script&lang=ts"
export * from "./StandingsListSection.vue?vue&type=script&lang=ts"
import style0 from "./StandingsListSection.vue?vue&type=style&index=0&id=2c0bff76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0bff76",
  null
  
)

export default component.exports